// Command palette (⌘/Ctrl-K): fuzzy-ish launcher for navigation, tools, folders,
// bookmarks, recents, and tab actions. The list itself is in commands.js.
import { commands, loadSettingsIndex } from "./commands.js";

let overlay, input, listEl, items = [], sel = 0, open = false;

function build() {
	overlay = document.createElement("div");
	overlay.className = "rv-palette"; overlay.hidden = true;
	const box = document.createElement("div"); box.className = "rv-palette-box";
	box.setAttribute("role", "dialog"); box.setAttribute("aria-modal", "true"); box.setAttribute("aria-label", "Command palette");
	input = document.createElement("input");
	input.className = "rv-palette-input"; input.type = "text"; input.spellcheck = false;
	input.setAttribute("aria-label", "Command palette");
	input.setAttribute("role", "combobox"); input.setAttribute("aria-expanded", "true"); input.setAttribute("aria-controls", "rv-palette-list"); input.setAttribute("aria-autocomplete", "list");
	input.placeholder = "Type a command, site, setting or search…";
	listEl = document.createElement("div"); listEl.className = "rv-palette-list"; listEl.id = "rv-palette-list"; listEl.setAttribute("role", "listbox");
	box.append(input, listEl); overlay.appendChild(box);
	document.body.appendChild(overlay);
	overlay.addEventListener("mousedown", (e) => { if (e.target === overlay) closePalette(); });
	input.addEventListener("input", () => render(input.value));
	input.addEventListener("keydown", onKey);
}

function render(query) {
	items = commands(query);
	sel = 0;
	listEl.textContent = "";
	items.forEach((c, i) => {
		const row = document.createElement("div");
		row.className = "rv-palette-item" + (i === sel ? " sel" : "");
		row.setAttribute("role", "option"); row.id = "rv-pal-opt-" + i; row.setAttribute("aria-selected", i === sel ? "true" : "false");
		const main = document.createElement("span"); main.className = "rv-palette-title"; main.textContent = c.title;
		row.appendChild(main);
		if (c.sub) { const s = document.createElement("span"); s.className = "rv-palette-sub"; s.textContent = c.sub; row.appendChild(s); }
		if (c.kind) { const k = document.createElement("span"); k.className = "rv-palette-kind"; k.textContent = c.kind; row.appendChild(k); }
		row.addEventListener("mousemove", () => setSel(i));
		row.addEventListener("click", () => run(i));
		listEl.appendChild(row);
	});
	if (items.length) input.setAttribute("aria-activedescendant", "rv-pal-opt-0"); else input.removeAttribute("aria-activedescendant");
}

function setSel(i) {
	if (i < 0 || i >= items.length) return;
	sel = i;
	[...listEl.children].forEach((el, j) => { const on = j === sel; el.classList.toggle("sel", on); el.setAttribute("aria-selected", on ? "true" : "false"); });
	const el = listEl.children[sel];
	if (el) { el.scrollIntoView({ block: "nearest" }); if (input) input.setAttribute("aria-activedescendant", el.id); }
}

function run(i) {
	const c = items[i];
	if (!c) return;
	closePalette();
	try { c.run(); } catch (e) {}
}

function onKey(e) {
	if (e.key === "ArrowDown") { e.preventDefault(); setSel(Math.min(sel + 1, items.length - 1)); }
	else if (e.key === "ArrowUp") { e.preventDefault(); setSel(Math.max(sel - 1, 0)); }
	else if (e.key === "Enter") { e.preventDefault(); run(sel); }
	else if (e.key === "Escape") { e.preventDefault(); closePalette(); }
	else if (e.key === "Tab") { e.preventDefault(); } // the palette is modal: Escape closes it
}

let opener = null;
export function openPalette() {
	if (!overlay) build();
	if (!open) opener = document.activeElement;
	open = true; overlay.hidden = false;
	input.value = ""; render("");
	input.focus();
	loadSettingsIndex(() => { if (open && input.value.trim()) render(input.value); });
}
export function closePalette() {
	const wasFocused = overlay && overlay.contains(document.activeElement);
	open = false;
	if (overlay) overlay.hidden = true;
	// Give focus back to where it was (a command that moves focus runs after this and wins).
	if (wasFocused && opener && opener.isConnected && opener !== document.body) { try { opener.focus(); } catch (e) {} }
	opener = null;
}
export function togglePalette() { open ? closePalette() : openPalette(); }
